import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import HomeSectionTitle from '../HomeSectionTitle'
import HomeMonthSlider from './HomeMonthSlider'
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function HomeMonth() {
    const [dateData, setDateData] = useState(new Date());
    const currentDate = new Date()
    const prevDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    // useEffect(() => {
    //     console.log(dateData);
    // }, [dateData])

    const [isOpen, setIsOpen] = useState(false);
    const toggleCalendar = () => {
        setIsOpen(!isOpen);
    };
    const changeDate = (date) => {
        toggleCalendar()
        setDateData(date)
    };
    return (
        <div>
            <div className='w-full mt-12'>
                <div className='pl-[0.625rem] mb-3'>
                    <HomeSectionTitle title="month" />
                </div>
                <div className='pl-[0.625rem] flex items-center mb-6'>
                    <div className='font-firstFont text-sm text-transparentWhite8'>
                        Most viewed data of
                    </div>
                    <div className='relative'>
                        <div className="cursor-pointer openHomeCalendar" onClick={toggleCalendar}>
                            {moment(dateData).format('MMM YYYY')}
                        </div>
                        {isOpen && (
                            <div className='absolute z-20 homeCalendar'>
                                <DatePicker
                                    dateFormat="MM/yyyy"
                                    selected={dateData}
                                    minDate={prevDate}
                                    maxDate={currentDate}
                                    onChange={(date) => changeDate(date)}
                                    showMonthYearPicker
                                    inline
                                />
                            </div>
                        )}
                    </div>

                </div>


                <HomeMonthSlider />
                <div className='mt-5'>
                    <NavLink to='/' className="white-button">
                        Search
                    </NavLink>
                </div>
            </div>
        </div>
    )
}
